var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-wrap d-flex justify-center align-center",style:({ 'background-color': _vm.bgColor, 'color': _vm.color })},[_vm._v(" "+_vm._s(_vm.count)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }